import React from "react";
import LogoYellowPng from '../../assets/img/logo/img_yelow.png'

const LogoYellow = () => {
    return <div className="logo">
        <img src={LogoYellowPng} alt="Logo" className="w-100 h-100"/>
    </div>
}

export default LogoYellow;